module.exports = __webpack_public_path__ + "img/header-bg-mobile.6e9b2439.png";